<template>
  <div class="animated fadeIn">
    <FiltersAttributionsTreated @apply="getCoachsAttributionsTreatedStats" />

    <div class="card card-inverse card-info text-center" v-if="loading">
      <div class="card-block">
        <blockquote class="card-blockquote">Chargement en cours ...</blockquote>
      </div>
    </div>

    <div class="card text-center" v-else-if="data.length === 0">
      <div class="card-block">
        <blockquote class="card-blockquote">
          Aucune données, appliquer ou modifier les filtres
        </blockquote>
      </div>
    </div>

    <RankAttributionsTreatedDetails v-else :coachs="data" />
  </div>
</template>

<script>
import FiltersAttributionsTreated from "@/components/coach-manager/attributions-treated/FiltersAttributionsTreated.vue";
import RankAttributionsTreatedDetails from "@/components/coach-manager/attributions-treated/RankAttributionsTreatedDetails.vue";

export default {
  components: {
    FiltersAttributionsTreated,
    RankAttributionsTreatedDetails,
  },

  data() {
    return {
      loading: false,
      data: [],
    };
  },

  methods: {
    async getCoachsAttributionsTreatedStats(filters) {
      try {
        this.loading = true;
        this.data = [];

        const { data } = await this.$api.get(
          "/users/coachs/attributions-treated/stats",
          {
            params: {
              filters: {
                ...filters,
                clientType: filters.clientType || undefined,
                coach: filters.coach || undefined,
                coachManagers: filters.coachManagers.map(({ value }) => value),
                departments: filters.departments.map(({ value }) => value),
              },
            },
          },
        );

        this.data = data;
      } catch (e) {
        this.$errorToast(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
